import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import * as Styled from 'shared/dialogs/delete-goal/delete-goal.style';

export type DeleteGoalsMessageProps = {
  count: number;
  onSubmit: () => void;
  onCancel: () => void;
};

export const DeleteGoalsMessage: React.FC<DeleteGoalsMessageProps> = ({
  count,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('forms.delete-goals.message.title', { count })}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('forms.delete-goals.message.description', { count })}
        </Typography>
        <Typography variant="body2">
          {t('forms.delete-goal.message.warning')}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          color={Colors.Inherit}
          onClick={onCancel}
        >
          {t('forms.delete-goal.message.buttons.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('forms.delete-goal.message.buttons.submit.label')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
